import { render, staticRenderFns } from "./coursewareWithClass.vue?vue&type=template&id=5cd5a8c0&scoped=true"
import script from "./coursewareWithClass.vue?vue&type=script&lang=js"
export * from "./coursewareWithClass.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd5a8c0",
  null
  
)

export default component.exports